import React from 'react';
import LegalDialog from './ui/LegalDialog';

const sections = [
  {
    title: '1. Information Collection',
    copy: 'We may collect details such as name, email address, phone number, and information provided during signup or platform interactions to support account access and communication.',
  },
  {
    title: '2. Data Protection',
    copy: 'We use technical and organizational safeguards to protect personal information. No internet transmission or storage method is completely secure, and users acknowledge that inherent risk.',
  },
  {
    title: '3. Sharing Information',
    copy: 'We do not sell or rent personal information. We may share information with trusted service providers or when required by law, legal process, or safety obligations.',
  },
  {
    title: '4. Cookies and Tracking Technologies',
    copy: 'Clear Horizons may use cookies and similar technologies to improve the experience, remember preferences, analyze site traffic, and enhance performance.',
  },
  {
    title: '5. Your Rights and Choices',
    copy: 'Users may contact us with questions or concerns about how personal data is handled, and we will respond in accordance with applicable requirements.',
  },
  {
    title: '6. Changes to Privacy Policy',
    copy: 'We may update this policy to reflect changes in practices, technology, or legal requirements. Users are encouraged to review it periodically.',
  },
];

function PrivacyModal({ show, onClose }) {
  return (
    <LegalDialog
      show={show}
      onClose={onClose}
      title="Privacy Policy"
      intro="Your privacy is important to us. This policy explains how Clear Horizons collects, uses, and safeguards information when users interact with our services."
      sections={sections}
    />
  );
}

export default PrivacyModal;
